import { compose } from '@beef/utils';
import { withDataConverter } from '@beef/react';
import { getWindow } from "../../../../utils/window";
import { getAccountType } from "../../../../utils/analytics";
import { ymPushParams } from "../../../../utils/ym.alternative";
import { getAnalyticsConverter } from "./analytics";
import { BackButton as _BackButton } from "./BackButton";
export var BackButton = compose(withDataConverter(getAnalyticsConverter({
  getWindow: getWindow,
  getAccountType: getAccountType,
  ymPushParams: ymPushParams
})))(_BackButton);